let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fi75i")).then(() => parcelRequire('5QCdA'));